import React from "react";
import styled from "styled-components";

const CardContainer = styled.div`
  background: linear-gradient(180deg, #ffffff, #f5f5f5);
  color: #000000;
  text-align: left;
  padding: 50px 40px;
  border-radius: 0; /* Sin bordes redondeados */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-width: 1200px;
  margin: 0 auto 20px auto;
  position: relative;
  font-family: 'Merriweather', serif; /* Fuente elegante */
`;

const HighlightBar = styled.div`
  width: 80px;
  height: 4px;
  background-color: #e63946;
  margin-bottom: 25px;
`;

const LargeText = styled.div`
  font-size: 3.2rem;
  font-weight: 800;
  margin-bottom: 12px;
  line-height: 1.1;
`;

const SubText = styled.div`
  font-size: 1.4rem;
  color: #444;
  line-height: 1.6;
`;

const Source = styled.div`
  font-size: 1rem;
  color: #e63946;
  font-style: italic;
  margin-top: 20px;
`;

const DescriptionText = styled.p`
  max-width: 1200px;
  margin: 30px auto 0 auto;
  padding: 0 40px;
  font-size: 1.2rem;
  line-height: 1.8;
  color: #333;
  font-family: 'Merriweather', serif;
`;

const BlockchainMarketCard = () => {
  return (
    <>
      <CardContainer>
        <HighlightBar />
        <LargeText>$248,900 millones</LargeText>
        <SubText>
          Valor estimado del mercado global de blockchain en 2029.
        </SubText>
        <Source>Fuente: Markets and Markets</Source>

      </CardContainer>

      <DescriptionText>
        La tecnología blockchain ha revolucionado la forma en que se gestionan
        los datos y las transacciones, ofreciendo un sistema descentralizado,
        seguro y transparente. A medida que más sectores adoptan esta
        tecnología, el potencial de crecimiento y las oportunidades laborales
        continúan expandiéndose, generando una demanda creciente de
        profesionales especializados en todo el mundo.
      </DescriptionText>
    </>
  );
};

export default BlockchainMarketCard;
